import React, { FC } from "react";
import Link from "../../ActionsSelectors/Link/Link";
import ProductTitle from "../../DataDisplay/ProductTitle/ProductTitle";
import { IProductDescription } from "../ProductCard.interface";

export interface IProductIntroProps {
  /**
   * The type used for Product description presentation
   *
   * @type {IProductDescription}
   */
  description: IProductDescription;
}

const ProductIntro: FC<IProductIntroProps> = (props) => {
  const { description } = props;
  const { brand, product, sports } = description;

  return (
    <div className="product-intro">
      <ProductTitle
        variant="PLP"
        brandName={brand?.text}
        productName={product?.text}
        productLink={{ href: product?.href }}
        brandLink={{ href: product?.href }}
      />
      {sports && <Link {...sports} classes={{ root: "product-category" }} />}
    </div>
  );
};

export default ProductIntro;
